import { render } from "./SelectTemplate.vue?vue&type=template&id=c5e3a9b0&scoped=true&ts=true"
import script from "./SelectTemplate.vue?vue&type=script&lang=ts"
export * from "./SelectTemplate.vue?vue&type=script&lang=ts"

import "./SelectTemplate.vue?vue&type=style&index=0&id=c5e3a9b0&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5e3a9b0"]])

export default __exports__